export default __webpack_public_path__ + "static/media/bg3.8db982de.jpg";